import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyLargeIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M2.79993 29.3333V8.04003C2.79993 5.36003 4.13333 4.01334 6.78666 4.01334H15.0933C17.7466 4.01334 19.0666 5.36003 19.0666 8.04003V29.3333",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M14.3333 12H7.73328C7.18661 12 6.73328 11.5467 6.73328 11C6.73328 10.4533 7.18661 10 7.73328 10H14.3333C14.88 10 15.3333 10.4533 15.3333 11C15.3333 11.5467 14.88 12 14.3333 12Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M14.3333 17H7.73328C7.18661 17 6.73328 16.5467 6.73328 16C6.73328 15.4533 7.18661 15 7.73328 15H14.3333C14.88 15 15.3333 15.4533 15.3333 16C15.3333 16.5467 14.88 17 14.3333 17Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M11 30.3333C10.4533 30.3333 10 29.88 10 29.3333V24.3333C10 23.7867 10.4533 23.3333 11 23.3333C11.5467 23.3333 12 23.7867 12 24.3333V29.3333C12 29.88 11.5467 30.3333 11 30.3333Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M30.6667 28.3333H27.64V24.3333C28.9067 23.92 29.8267 22.7333 29.8267 21.3333V18.6667C29.8267 16.92 28.4 15.4933 26.6534 15.4933C24.9067 15.4933 23.48 16.92 23.48 18.6667V21.3333C23.48 22.72 24.3867 23.8933 25.6267 24.32V28.3333H1.33337C0.786707 28.3333 0.333374 28.7867 0.333374 29.3333C0.333374 29.88 0.786707 30.3333 1.33337 30.3333H26.5734C26.6 30.3333 26.6133 30.3467 26.64 30.3467C26.6667 30.3467 26.6801 30.3333 26.7067 30.3333H30.6667C31.2134 30.3333 31.6667 29.88 31.6667 29.3333C31.6667 28.7867 31.2134 28.3333 30.6667 28.3333Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_6)
  ]))
}
}

})